/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IDTokenProvider } from './IDTokenProvider';
import {
    IDTokenProviderFromJSON,
    IDTokenProviderFromJSONTyped,
    IDTokenProviderToJSON,
} from './IDTokenProvider';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    lastLogin?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    dateJoined?: Date;
    /**
     * Required. 256 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @type {string}
     * @memberof User
     */
    username: string;
    /**
     * 
     * @type {IDTokenProvider}
     * @memberof User
     */
    loginProvider: IDTokenProvider | null;
    /**
     * Returns true if this user is managed by IdM itself e.g. thus can be deleted from a tenant via Accounts table.
     * Returns false if this user's access is instead determined by its group membership in an external provider like Azure.
     * @type {boolean}
     * @memberof User
     */
    readonly locallyManaged: boolean;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "loginProvider" in value;
    isInstance = isInstance && "locallyManaged" in value;

    return isInstance;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastLogin': !exists(json, 'last_login') ? undefined : (json['last_login'] === null ? null : new Date(json['last_login'])),
        'firstName': !exists(json, 'first_name') ? undefined : json['first_name'],
        'lastName': !exists(json, 'last_name') ? undefined : json['last_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'dateJoined': !exists(json, 'date_joined') ? undefined : (new Date(json['date_joined'])),
        'username': json['username'],
        'loginProvider': IDTokenProviderFromJSON(json['login_provider']),
        'locallyManaged': json['locally_managed'],
    };
}

export function UserToJSON(value?: User | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'last_login': value.lastLogin === undefined ? undefined : (value.lastLogin === null ? null : value.lastLogin.toISOString()),
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
        'date_joined': value.dateJoined === undefined ? undefined : (value.dateJoined.toISOString()),
        'username': value.username,
        'login_provider': IDTokenProviderToJSON(value.loginProvider),
    };
}

